import api from './axios';

export interface WishlistItem {
  id: number;
  customerId: string;
  productId: number;
  createdAt: string;
  product?: {
    id: number;
    name: string;
    description: string;
    imageUrl: string;
    price: number;
  };
}

export interface WishlistResponse {
  success: boolean;
  item: WishlistItem;
  message: string;
}

export const wishlistApi = {
  addToWishlist: async (productId: number): Promise<WishlistResponse> => {
    try {
      const response = await api.post('/api/shop/wishlist', {
        productId,
      });
      return response.data;
    } catch (error) {
      console.error('Error adding to wishlist:', error);
      throw error;
    }
  },

  removeFromWishlist: async (wishlistId: number): Promise<WishlistResponse> => {
    try {
      const response = await api.delete(`/api/shop/wishlist/${wishlistId}`);
      return response.data;
    } catch (error) {
      console.error('Error removing from wishlist:', error);
      throw error;
    }
  },

  getWishlist: async (): Promise<WishlistItem[]> => {
    try {
      const response = await api.get('/api/shop/wishlist');
      return response.data;
    } catch (error) {
      console.error('Error fetching wishlist:', error);
      return [];
    }
  },

  checkWishlistStatus: async (productId: number): Promise<{ isInWishlist: boolean; wishlistId?: number }> => {
    try {
      const response = await api.get(`/api/shop/wishlist/check/${productId}`);
      return {
        isInWishlist: response.data.isInWishlist || false,
        wishlistId: response.data.wishlistId || response.data.item?.id
      };
    } catch (error) {
      console.error('Error checking wishlist status:', error);
      return { isInWishlist: false };
    }
  },
};
